import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function usePersistJwt() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        let jwt = params.get("jwt");

        // Fallback 1: try to read jwt from hash (e.g., "#/form?jwt=...")
        if (!jwt && location.hash) {
            const hash = location.hash; // includes leading '#'
            const qIndex = hash.indexOf("?");
            if (qIndex !== -1) {
                const hashQuery = hash.substring(qIndex + 1);
                const hashParams = new URLSearchParams(hashQuery);
                jwt = hashParams.get("jwt") || jwt;
            }
        }

        // Fallback 2: extract jwt from path segment like "/form/jwt/<token>"
        if (!jwt && location.pathname) {
            const match = location.pathname.match(/\/jwt\/([^/?#]+)/);
            if (match && match[1]) jwt = decodeURIComponent(match[1]);
        }
        if (jwt) {
            try {
                sessionStorage.setItem("jwt", jwt);
            } catch (_) {
                // ignore storage errors (e.g., disabled cookies/storage)
            }

            // Clean JWT from URL while preserving other params
            params.delete("jwt");
            const nextSearch = params.toString();
            navigate(
                {
                    pathname: location.pathname,
                    search: nextSearch ? `?${nextSearch}` : "",
                },
                { replace: true }
            );
        } else {
            if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.log("No JWT in search/hash/path", {
                    search: location.search,
                    hash: location.hash,
                    pathname: location.pathname,
                });
            }
        }
    }, [location, navigate]);
}


